import React from 'react';
import { Link } from 'react-router-dom';

const Data = () => {
  return (
    <div className="home__data">
      <h1 className="home__title">
        NeoApps
        <svg
          className="home__icon"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.1906 3.30834C10.9766 2.94126 10.3527 2.71865 9.71907 3.0808C9.08771 3.44163 8.97667 4.07767 9.187 4.43836L11.7127 8.76947C11.9213 9.12729 11.8004 9.58651 11.4426 9.79517C11.0848 10.0038 10.6255 9.88291 10.4169 9.52509L7.04934 3.75027C6.83528 3.38319 6.21147 3.16058 5.5778 3.52273C4.94644 3.88356 4.8354 4.5196 5.04573 4.88029L8.83422 11.377C9.04288 11.7348 8.92196 12.194 8.56414 12.4027C8.20632 12.6113 7.7471 12.4904 7.53844 12.1326L5.85467 9.24517C5.64061 8.8781 5.0168 8.65548 4.38313 9.01763C3.75177 9.37846 3.64073 10.0145 3.85106 10.3752L7.63955 16.8719C9.24849 19.631 13.2188 20.5263 16.5858 18.6021C19.9505 16.6791 21.1465 12.8376 19.5413 10.0849L17.0156 5.75382C16.8016 5.38675 16.1778 5.16413 15.5441 5.52628C14.9128 5.88711 14.8017 6.52315 15.012 6.88384L16.6958 9.77125C16.7966 9.94406 16.8241 10.15 16.7724 10.3432C16.7206 10.5364 16.5938 10.701 16.4201 10.8002C14.8776 11.6817 14.4049 13.3863 15.0802 14.5443C15.2889 14.9021 15.1679 15.3613 14.8101 15.57C14.4523 15.7787 13.9931 15.6577 13.7844 15.2999C12.8717 13.7347 13.2405 11.8501 14.4194 10.518C14.749 10.1456 14.8618 9.60391 14.6113 9.17433L11.1906 3.30834Z"
            fill="#1C274C"
          />
          <g opacity="0.5">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.41333 17.859C4.77115 17.6504 5.23037 17.7713 5.43903 18.1291C6.26589 19.5471 7.52998 20.6193 9.08886 21.3151C9.46711 21.4839 9.63689 21.9274 9.46807 22.3057C9.29925 22.6839 8.85576 22.8537 8.47751 22.6849C6.666 21.8764 5.1462 20.6046 4.14325 18.8847C3.93459 18.5269 4.05551 18.0677 4.41333 17.859Z"
              fill="#1C274C"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.9053 3.92194C17.8914 2.88646 16.4454 2.50452 15.0299 2.9073C14.6315 3.02066 14.2166 2.78959 14.1033 2.39119C13.9899 1.99279 14.221 1.57792 14.6194 1.46456C16.5576 0.913072 18.574 1.43959 19.9771 2.8725C20.2669 3.16846 20.2619 3.64331 19.9659 3.9331C19.67 4.2229 19.1951 4.2179 18.9053 3.92194Z"
              fill="#1C274C"
            />
          </g>
        </svg>
      </h1>
      <h2 className="home__subtitle">Empowering Your Digital Transformation</h2>
      <p className="home__description">
        At NeoApps, we are a team of experts dedicated to crafting exceptional websites and mobile
        applications. Our talented professionals specialize in web design, development, and mobile
        solutions, ensuring that your digital presence is both innovative and impactful.
      </p>
      <Link to="/contact" className="button button--flex">
        Say hello
        <svg
          className="button__icon"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M14.2199 21.9352C13.0399 21.9352 11.3699 21.1052 10.0499 17.1352L9.32988 14.9752L7.16988 14.2552C3.20988 12.9352 2.37988 11.2652 2.37988 10.0852C2.37988 8.91525 3.20988 7.23525 7.16988 5.90525L15.6599 3.07525C17.7799 2.36525 19.5499 2.57525 20.6399 3.65525C21.7299 4.73525 21.9399 6.51525 21.2299 8.63525L18.3999 17.1252C17.0699 21.1052 15.3999 21.9352 14.2199 21.9352ZM7.63988 7.33525C4.85988 8.26525 3.86988 9.36525 3.86988 10.0852C3.86988 10.8052 4.85988 11.9052 7.63988 12.8252L10.1599 13.6652C10.3799 13.7352 10.5599 13.9152 10.6299 14.1352L11.4699 16.6552C12.3899 19.4352 13.4999 20.4252 14.2199 20.4252C14.9399 20.4252 16.0399 19.4352 16.9699 16.6552L19.7999 8.16525C20.3099 6.62525 20.2199 5.36525 19.5699 4.71525C18.9199 4.06525 17.6599 3.98525 16.1299 4.49525L7.63988 7.33525Z"
            fill="var(--container-color)"
          />
          <path
            d="M10.11 14.7052C9.92005 14.7052 9.73005 14.6352 9.58005 14.4852C9.29005 14.1952 9.29005 13.7152 9.58005 13.4252L13.16 9.83518C13.45 9.54518 13.93 9.54518 14.22 9.83518C14.51 10.1252 14.51 10.6052 14.22 10.8952L10.64 14.4852C10.5 14.6352 10.3 14.7052 10.11 14.7052Z"
            fill="var(--container-color)"
          />
        </svg>
      </Link>
    </div>
  );
};

export default Data;
